/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SceneDeviceAssignment,
    SceneDeviceAssignmentFromJSON,
    SceneDeviceAssignmentFromJSONTyped,
    SceneDeviceAssignmentToJSON,
} from './SceneDeviceAssignment';

/**
 * 
 * @export
 * @interface SceneDeviceAssignmentListResponse
 */
export interface SceneDeviceAssignmentListResponse {
    /**
     * 
     * @type {Array<SceneDeviceAssignment>}
     * @memberof SceneDeviceAssignmentListResponse
     */
    assignments: Array<SceneDeviceAssignment>;
}

export function SceneDeviceAssignmentListResponseFromJSON(json: any): SceneDeviceAssignmentListResponse {
    return SceneDeviceAssignmentListResponseFromJSONTyped(json, false);
}

export function SceneDeviceAssignmentListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SceneDeviceAssignmentListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assignments': ((json['assignments'] as Array<any>).map(SceneDeviceAssignmentFromJSON)),
    };
}

export function SceneDeviceAssignmentListResponseToJSON(value?: SceneDeviceAssignmentListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assignments': ((value.assignments as Array<any>).map(SceneDeviceAssignmentToJSON)),
    };
}

